'use strict';

var callBound = require('./callBound.js');

var $strSlice = callBound('String.prototype.slice');

var isPrefixOf = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};

module.exports = isPrefixOf;
